import {
  FETCH_PERMISSIONS_OVERVIEW,
  FETCH_PERMISSIONS_OVERVIEW_SUCCESS,
  FETCH_PERMISSIONS_OVERVIEW_FAILURE,
  FETCH_PERMISSION_HISTORY,
  FETCH_PERMISSION_HISTORY_SUCCESS,
  FETCH_PERMISSION_HISTORY_FAILURE,
} from "./constants";

/**
 * Load the whole workforce's stored permissions.
 *
 * @param {{ locationId?: string|number|null, includeEmployees?: boolean }} [payload]
 *   `locationId` scopes the list the way the dealer's own location switcher does; omit /
 *   null for the whole company. `includeEmployees` defaults to TRUE — the People lens
 *   wants the frontline band for promotion; pass `false` for managers + admins only.
 * @param {Function} [onSuccess] called with `{ employees, locations }`
 */
export const fetchPermissionsOverview = (payload, onSuccess) => ({
  type: FETCH_PERMISSIONS_OVERVIEW,
  payload,
  onSuccess,
});

export const fetchPermissionsOverviewSuccess = (payload) => ({
  type: FETCH_PERMISSIONS_OVERVIEW_SUCCESS,
  payload,
});

/** @param {{ forbidden?: boolean }} [payload] */
export const fetchPermissionsOverviewFailure = (payload) => ({
  type: FETCH_PERMISSIONS_OVERVIEW_FAILURE,
  payload,
});

/**
 * Load one employee's permission-change history.
 *
 * @param {{ uuid: string }} payload
 * @param {Function} [onSuccess] called with `{ uuid, available, entries }`
 */
export const fetchPermissionHistory = (payload, onSuccess) => ({
  type: FETCH_PERMISSION_HISTORY,
  payload,
  onSuccess,
});

export const fetchPermissionHistorySuccess = (payload) => ({
  type: FETCH_PERMISSION_HISTORY_SUCCESS,
  payload,
});

export const fetchPermissionHistoryFailure = (payload) => ({
  type: FETCH_PERMISSION_HISTORY_FAILURE,
  payload,
});
